const FUNDS_PARAMS = {
    per_page: 9999,
};

export { FUNDS_PARAMS };
